import {
  Component,
  OnInit,
  OnDestroy,
  signal,
  inject,
  computed,
  WritableSignal,
  effect,
  ChangeDetectionStrategy,
} from '@angular/core'
import { ListingItem } from 'depoto-core/src/models'
import { BaseListing } from '../_base-listing/base-listing'
import { CoreService, NotificationService } from '../../services'
import { checkoutsColumns, printStockExportsColumns } from '../../utils/definitions.util'
import { SchemaUtil } from '../../utils'
import { TranslateService } from '@ngx-translate/core'
import { StockExportService } from '../../services/entity-services/stockExport.service'
import { injectInfiniteQuery } from '@tanstack/angular-query-experimental'

@Component({
  selector: 'app-print-stock-exports',
  templateUrl: 'print-stock-exports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrintStockExportsComponent extends BaseListing implements OnInit, OnDestroy {
  private stockExportService = inject(StockExportService)

  reports: any[] = []
  listingColumns = signal(printStockExportsColumns)
  totalItems = computed(() => {
    console.error(this.queryStockExports.data())
    return 100
  })
  currentPage: number
  endPage: number
  refreshInterval: any = null
  loading = true
  // storageKey: WritableSignal<{ type: string; key: string }> = signal({ type: '', key: '' })
  sortProp = signal('created')
  sortDir = signal('desc')

  readonly queryStockExports = injectInfiniteQuery(() => ({
    queryKey: ['stockExports', { sortProp: this.sortProp(), sortDir: this.sortDir() }], // todo add  queryKey -> sort, filters, schema - columns
    queryFn: async ({ pageParam }) => {
      // const requestId = ++this.currentRequestId // unique ID per call
      return await this.stockExportService
        .getStockExports(
          {
            page: pageParam,
            sort: this.sortProp(),
            direction: this.sortDir(),
          },
          SchemaUtil.stock
        )
        .then(result => {
          // this.saveViewSettings('printStockExports', this.filters)
          return result
        })
    },
    initialPageParam: 1,
    getNextPageParam: result => {
      return Number(result?.paginator?.current) < Number(result?.paginator?.endPage)
        ? Number(result?.paginator?.current) + 1
        : undefined
    },
  }))

  constructor(
    protected core: CoreService,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {
    super(core)
    effect(() => {
      this.queryStockExports.data()
    })
    // this.getStorageKey()
  }

  ngOnInit() {
    // this.filters = this.loadViewSettings('printStockExports') || { ...DEFAULT_FILTERS } todo
    this.loadSorting('printStockExports')
    // this.filter() todo
  }

  ngOnDestroy() {
    this.stopRefreshing()
  }

  async createExportStocks(stocksExport) {
    this.loading = true
    try {
      this.startRefreshing('queryStockExports')
      await this.core.services.stockExport.create(stocksExport, { id: null }).then(() => {
        this.notificationService.success(this.translateService.instant('alert.stock.created'))
      })
      this.queryStockExports.refetch()
      // await this.filter(1)todo
    } catch (err) {
      console.error(err)
    } finally {
      this.loading = false
      // this.reloading = false
    }
  }

  downloadReport(report: any) {
    this.core.services.download.downloadDocumentAndShowInNewWindow(report.url)
  }
}
